import {
  ButtonCopy,
  ModalContent,
  ModalHeader,
  ModalSubHeader,
  ModalText,
  ModalTextWrap,
  ModalWrap,
} from './InformModalStyled';
import { ReactComponent as CopyIcon } from '../../images/copy.svg';
import React, { useState, useRef } from 'react';
import Modal from 'features/shared/Modal';
import { Space } from '@gr-monorepo/common/ui';
import { ReactComponent as DoneIcon } from '../../images/done.svg';
import MarkdownPreview from 'features/shared/ui/MarkdownPreview/MarkdownPreview';
import useUserData from 'hooks/useUserData';
import { useClickStreamContext } from 'features/shared/ClickStream';

interface ModalProps {
  onClose: () => void;
  title: string;
  text: string;
}

const CopyButton = ({ isCopied, onClick }: { isCopied: boolean; onClick: () => void }) => {
  return (
    <>
      {isCopied ? (
        <ButtonCopy color={'light_violet'} onClick={onClick}>
          <DoneIcon /> <span style={{ marginLeft: '8px' }}>скопировано</span>
        </ButtonCopy>
      ) : (
        <ButtonCopy color={'violet'} style={{ color: '#985EFF' }} onClick={onClick}>
          <CopyIcon /> <span style={{ marginLeft: '4px' }}>Скопировать сообщение</span>
        </ButtonCopy>
      )}
    </>
  );
};

const InformModal = ( {onClose, title, text}: ModalProps) => {
  const [isCopied, setIsCopied] = useState(false);
  const userData = useUserData()
  const cabmunId = userData?.id
  const markdownRef = useRef<HTMLDivElement>(null);

  const clickStream = useClickStreamContext()

  // replace utm_term {{cabmun_id}} with actual value in url
  const processedText = text.replace(/\{\{cabmun_id\}\}/g, String(cabmunId || ''));

  const handleCopyClick = () => {
    // Get plain text from the rendered markdown
    const plainText = markdownRef.current?.innerText || processedText;
    navigator?.clipboard?.writeText(plainText);
    
    clickStream.logPageEvent({
      eventType: 'priority-project-inform-button-copy-click',
      eventInfo: 'Копирование информации по приоритетному проекту региона',
      cd1: title
    })
    setIsCopied(true);
  };

  return (
    <Modal onClose={onClose} customModalWindow={ModalWrap}>
      <ModalContent>
        <ModalHeader>Проинформировать образовательные учреждения</ModalHeader>
        <Space size={8} axis="vertical" />
        <ModalSubHeader>{title}</ModalSubHeader>
        <ModalTextWrap>
          <ModalText ref={markdownRef}> <MarkdownPreview content={processedText} /></ModalText>
          <Space size={20} axis="vertical" />
          <CopyButton isCopied={isCopied} onClick={handleCopyClick} />
        </ModalTextWrap>
      </ModalContent>
    </Modal>
  );
};

export default InformModal;
